<template>
  <v-container fluid>
    <v-flex justify-center d-flex xs12 sm12 lg12 md12 xl12>
      <h2>FOGLIO ORE</h2>
    </v-flex>
    <v-flex justify-center d-flex xs12 sm12 lg12 md12 xl12>
      <v-btn
        fab
        outlined
        small
        left
        color="primary"
        @click="
          $refs.calendario.prev();
        "
      >
        <v-icon dark>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        fab
        outlined
        small
        left
        color="primary"
        @click="
          calendario = currentDate;
        "
      >
        <v-icon dark>mdi-calendar</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        fab
        outlined
        small
        left
        color="primary"
        @click="
          $refs.calendario.next();
        "
      >
        <v-icon dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-flex>
    <br />
    <v-flex d-flex xs12 sm12 lg12 md12 xl12>
      <h4>{{ mesi[selectedMonth] }} {{ selectedYear }}</h4>
    </v-flex>
    <v-flex d-flex xs12 lg12 md12 sm12 xl12>
      <!--Calendario visalizzazione commesse-->
      <v-calendar
        :events="eventiVisualizzati"
        v-model="calendario"
        :event-more="false"
        type="month"
        :value="currentDate"
        color="accent"
        ref="calendario"
        :event-color="getEventColor"
        :weekdays="weekdays"
        @click:event="showEvent"
      >
        <template v-slot:day-label="{ present, past, date, day }">
          <v-btn
            :color="getColorePermesso(getPermessoGiorno(date).type)"
            v-bind:class="{ accent: present }"
            depressed
            fab
            small
            rounded
            @click="apriDialogRegistrazioneOre(day, date)"
            >{{ day }}</v-btn
          >
          <v-badge
            v-if="!$vuetify.breakpoint.xs && listaOreGiornaliere[date] > 0"
            color="primary"
          >
            <template v-slot:badge>{{ listaOreGiornaliere[date] }}</template>
          </v-badge>
        </template>
      </v-calendar>
    </v-flex>
    <br />
    <v-flex d-flex xs12 sm12 lg12 md12 xl12>
      <v-btn text @click="apriSchedaMese()">Scheda mese</v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="update()">
        Aggiorna
        <v-icon>loop</v-icon>
      </v-btn>
    </v-flex>
    <!--Fine calendario-->
    <!--Dialog che visualizza il dettaglio giornaliero-->
    <v-dialog
      v-model="dialogRegistrazioneOre"
      xs4
      sm4
      md4
      lg4
      xl4
      max-width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :hide-overlay="$vuetify.breakpoint.smAndDown"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ selectedDay }} {{ mesi[selectedMonth] }}
            {{ selectedYear }}</span
          >
          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="buttonSaveDisabled || aggiuntaDisabled(selectedDate)"
          >
            <v-icon medium @click="salvaGiorno()">save</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon medium @click="resetDialogRegistrazioneOre()">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-select
                v-model="permesso"
                :items="listaTipoPermesso"
                item-text="name"
                item-value="value"
                no-data-text="Nessun elemento"
                label="Tipo permesso"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <h4>Attività registrate</h4>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-card class="mx-auto scrollable" tile>
                <v-list v-if="eventiGiorno.length > 0">
                  <v-list-item-group>
                    <v-list-item
                      class="puntatore"
                      v-for="evento in eventiGiorno"
                      :key="evento.rapportino.fct_timesheetwh_id"
                      dense
                      color="primary"
                      flat
                    >
                      <v-list-item-content
                        @click="apriDialogInserimento(evento.rapportino)"
                        >{{ evento.rapportino.selectdesc }}</v-list-item-content
                      >
                      <v-list-item-action
                        @click="apriDialogInserimento(evento.rapportino)"
                      >
                        <v-badge color="primary">
                          <template v-slot:badge>{{
                            sommaOre(evento.rapportino)
                          }}</template>
                        </v-badge>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
              <br />
              <v-flex
                xs12
                sm12
                md12
                lg12
                xl12
                v-if="commesseRecenti.length > 0"
              >
                <h4>Commesse recenti</h4>
              </v-flex>
              <v-card class="mx-auto scrollable" tile>
                <v-list v-if="commesseRecenti.length > 0">
                  <v-list-item-group>
                    <v-list-item
                      class="puntatore"
                      v-for="commessa in commesseRecenti"
                      :key="commessa.fct_timesheetwh_id"
                      dense
                      color="primary"
                      flat
                    >
                      <v-list-item-content
                        @click="apriDialogInserimentoRecente(commessa)"
                        >{{ commessa.selectdesc }}</v-list-item-content
                      >
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
              <br />
              <v-btn
                :disabled="aggiuntaDisabled(selectedDate)"
                @click="
                  resetDialogInserimento();
                  dialogInserimento = true;
                "
                >Aggiungi rapportino</v-btn
              >
            </v-flex>
            <br />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="resetDialogRegistrazioneOre"
            >Chiudi</v-btn
          >
          <v-btn
            color="primary"
            text
            :disabled="aggiuntaDisabled(selectedDate)"
            @click="
              salvaGiorno();
              dialogRegistrazioneOre = false;
            "
            >Salva</v-btn
          >
        </v-card-actions>
      </v-card>
      <!--Dialog per l'inserimento del rapporto-->
    </v-dialog>
    <!--Fine dialog che visualizza il dettaglio giornaliero-->
    <v-dialog
      v-model="dialogInserimento"
      xs4
      sm4
      md4
      lg4
      xl4
      max-width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :hide-overlay="$vuetify.breakpoint.smAndDown"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">Rapportino {{ dataRapportino }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="buttonSaveDisabled || aggiuntaDisabled(selectedDate)"
          >
            <v-icon medium @click="inserisciAggiornaRapportino()">save</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon medium @click="resetDialogInserimento()">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-flex
              xs12
              sm12
              md12
              lg12
              xl12
              justify-center
              v-show="!updateRapportino"
            >
              <v-btn-toggle v-model="sceltaCommessaAttivita" mandatory>
                <v-btn>Commessa</v-btn>
                <v-btn>Foglio Lavoro</v-btn>
              </v-btn-toggle>
            </v-flex>
            <br />
            <v-flex v-if="sceltaCommessaAttivita == 0" xs12 sm12 md12 lg12 xl12>
              <h4>COMMESSA</h4>
              <v-autocomplete
                :disabled="updateRapportino"
                v-model="commessaSelezionata"
                hide-selected
                no-data-text="Nessuna commessa"
                placeholder="Scrivi per cercare"
                prepend-icon="mdi-database-search"
                :items="commesseAttive"
                item-text="selectdesc"
                item-value="c_project_id"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="sceltaCommessaAttivita == 1" xs12 sm12 md12 lg12 xl12>
              <h4>CLIENTE</h4>
              <v-autocomplete
                :disabled="updateRapportino"
                v-model="clienteSelezionato"
                hide-selected
                no-data-text="Nessun cliente"
                placeholder="Scrivi per cercare"
                prepend-icon="mdi-account"
                :items="listaBPartner"
                item-text="bpname"
                item-value="c_bpartner_id"
              ></v-autocomplete>
              <h4>NUMERO FOGLIO ORE</h4>
              <v-text-field
                :disabled="updateRapportino"
                label="Numero Foglio Ore"
                type="number"
                v-model="numFoglioOre"
              ></v-text-field>
            </v-flex>
            <br />
            <v-flex xs12 sm12 md12 lg12 xl12>
              <h4>ORE INTERNE</h4>
              <v-text-field
                type="number"
                label="Ore Interne"
                v-model="oreInterne"
                @focus="$event.target.select()"
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <h4>ORE ESTERNE</h4>
              <v-text-field
                type="number"
                v-model="oreMontaggio"
                @focus="$event.target.select()"
                :rules="rules"
              ></v-text-field>
              <h4>ORE ASSISTENZA</h4>
              <v-text-field
                type="number"
                v-model="oreAssistenza"
                @focus="$event.target.select()"
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <h4>ORE VIAGGIO</h4>
              <v-text-field
                type="number"
                v-model="oreViaggio"
                @focus="$event.target.select()"
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 v-if="sceltaCommessaAttivita == 1">
              <h4>MATERIALE UTILIZZATO</h4>
              <v-textarea
                type="number"
                v-model="materialeUtilizzato"
                @focus="$event.target.select()"
                :rules="rules"
              ></v-textarea>
            </v-flex>
            <v-flex d-flex xs12 sm12 md12 lg12 xl12>
              <v-checkbox label="Pernotto" v-model="pernotto"></v-checkbox>
              <v-spacer></v-spacer>
              <v-select
                v-if="pernotto"
                v-model="tipoPernotto"
                :items="listaTipoPernotto"
                item-value="value"
                item-text="name"
                label="Tipo Pernotto"
                noDataText="Nessun elemento"
              ></v-select>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            v-if="updateRapportino"
            text
            @click="eliminaRapportino()"
            :disabled="buttonSaveDisabled || aggiuntaDisabled(selectedDate)"
          >
            <v-icon>delete</v-icon>Elimina
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="accent" text @click="resetDialogInserimento()"
            >Chiudi</v-btn
          >
          <v-btn
            color="primary"
            text
            :disabled="buttonSaveDisabled || aggiuntaDisabled(selectedDate)"
            @click.prevent="inserisciAggiornaRapportino()"
            >Salva</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Fine dialog inserimento ore-->

    <!--Dialog scheda mese-->
    <v-dialog
      v-model="dialogSchedaMese"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :hide-overlay="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex d-flex xs9 lg11
            >{{ mesi[selectedMonth] }} {{ selectedYear }}</v-flex
          >
          <v-flex xs3 lg1>
            <v-btn color="accent" justify-end @click="dialogSchedaMese = false"
              >Chiudi</v-btn
            >
          </v-flex>
        </v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          hide-default-header
          :headers="headersSchedaMese"
          :items="schedaMese"
        ></v-data-table>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" @click="dialogSchedaMese = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Modulo per un dialog di scelta si/no-->
    <confirm ref="confirm"></confirm>
    <!--SnackBar per la visualizzazione di errori-->
    <v-snackbar
      v-model="errorSnackbar"
      color="error"
      :top="$vuetify.breakpoint.smAndDown"
    >
      {{ errorText }}
      <v-btn icon @click="errorSnackbar = false">
        <v-icon>cancel</v-icon>
      </v-btn>
    </v-snackbar>
    <!--Dialog per il caricamento-->
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Salvataggio rapportino
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import confirm from "../components/ConfirmDialog.vue";
import mixinCommonComp from "../mixin/MixingCommonComp";

export default {
  mixins: [mixinCommonComp],
  components: {
    confirm,
  },
  data() {
    return {
      calendario: "",
      mesi: [
        "",
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      dialogRegistrazioneOre: false,
      dialogSchedaMese: false,
      schedaMese: [],
      headersSchedaMese: [
        { text: "N", width: "1%", value: "num", sortable: false },
        { text: "Giorno", width: "1%", value: "giorno", sortable: false },
        { text: "Interne", width: "1%", value: "interne", sortable: false },
        { text: "Esterne", width: "1%", value: "esterne", sortable: false },
        { text: "Viaggio", width: "1%", value: "viaggio", sortable: false },
        { text: "Pernotto", width: "1%", value: "pernotto", sortable: false },
      ],
      listaTipoPermesso: [
        { name: "Lavorativo", value: "L", color: "" },
        { name: "Ferie", value: "F", color: "pink lighten-4" },
        { name: "Permesso", value: "PR", color: "red lighten-1" },
        { name: "Malattia", value: "M", color: "red lighten-1" },
      ],
      eventi: [
        {
          name: "prova",
          start: "1980-01-01",
        },
      ],
      listaTipoPernotto: [
        { name: "Italia", value: "I" },
        { name: "Europa", value: "E" },
        { name: "Mondo", value: "M" },
      ],
      giorniSettimana: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      listaOreGiornaliere: {},
      eventiGiorno: [],
      dialogInserimento: false,
      sceltaCommessaAttivita: 0,
      oreInterne: 0,
      oreAssistenza: 0,
      oreMontaggio: 0,
      oreViaggio: 0,
      commessaSelezionata: -1,
      clienteSelezionato: -1,
      numFoglioOre: "",
      permesso: "",
      pernotto: false,
      tipoPernotto: "",
      materialeUtilizzato: "",
      commesseAttive: [],
      listaBPartner: [],
      listaFerieMalattie: [],
      updateRapportino: false,
      selectedDate: "",
      selectedDay: 1,
      idRapportino: -1,
      errorSnackbar: false,
      errorText: "",
      listaPernotto: [],
      dataRapportino: "",
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      buttonSaveDisabled: false,
      rules: [
        (v) => {
          var stringa = v + "";
          var oraMinuti = stringa.split(".");
          if (oraMinuti[1] == null) {
            return true;
          } else {
            if (oraMinuti[1].length == 1) {
              oraMinuti[1] += "0";
            }
            if (oraMinuti[1].length == 2) {
              var risultato = parseInt(oraMinuti[1] % 15);
              if (risultato != 0 || oraMinuti[1] >= 60) {
                return "I minuti devono essere multipli di 15";
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
          return "Error";
        },
      ],
      commesseRecenti: [],
      loadingDialog: false,
    };
  },
  methods: {
    aggiuntaDisabled(dataSelezionata1) {
      if (this.$store.state.abilitatazioneModificaOre) return false;
      //console.log("dataSelezionata1");
      //console.log(dataSelezionata1);

      let dataSelezionata = new Date(
        this.selectedYear,
        this.selectedMonth - 1,
        this.selectedDay
      );

      var today = new Date();
      var todayTimestamp = today.getTime();
      var todayDay = today.getUTCDate();

      var selTimestamp = dataSelezionata.getTime();
      var selday = dataSelezionata.getUTCDate();

      var valoreRitorno = false;

      //se è vecchio più di un mese è disabilitato l'inserimento
      if (todayTimestamp - selTimestamp > 2629800000) {
        //console.log("Più vecchio di un mese");
        valoreRitorno = true;
      } else {
        today.setHours(0, 0, 0, 0);
        Date.prototype.GetFirstDayOfWeek = function () {
          return new Date(this.setDate(this.getDate() - this.getDay() + 1));
        };

        Date.prototype.GetLastDayOfWeek = function () {
          if (this.getDay() == 0) return this;
          return new Date(this.setDate(this.getDate() - this.getDay() + 7));
        };

        valoreRitorno =
          today.GetLastDayOfWeek().getTime() ==
          dataSelezionata.GetLastDayOfWeek().getTime();
        valoreRitorno =
          valoreRitorno &&
          today.GetFirstDayOfWeek().getTime() ==
            dataSelezionata.GetFirstDayOfWeek().getTime();
        valoreRitorno = !valoreRitorno;
      }

      /*else if (todayDay <= 15) {
        // data nei primi 15 giorni del mese
        //console.log("<= 15");
        var startDate = new Date(today.getFullYear(), today.getMonth(), 0);
        var stopDate = new Date(today.getFullYear(), today.getMonth(), 15);

        if (
          selTimestamp < startDate.getTime() ||
          selTimestamp > stopDate.getTime()
        ) {
          valoreRitorno = true;
        }
      } else if (todayDay > 15) {
        // data nei secondi 15 giorni del mese
        //console.log("> 15");
        var startDate = new Date(today.getFullYear(), today.getMonth(), 15);
        var stopDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        stopDate = new Date(stopDate - 1);

        //console.log(startDate + " + + "  + stopDate)

        if (
          selTimestamp < startDate.getTime() ||
          selTimestamp > stopDate.getTime()
        ) {
          valoreRitorno = true;
        }
      }*/

      //let dataAttuale = new Date().getTime();
      //let dataO = new Date().getTime();
      //return dataO - dataV > 2678400000;

      //disattivazione controllo come da richiesta del cliente del 10/09/2020
      //console.log(valoreRitorno)

      return valoreRitorno;
    },
    apriDialogRegistrazioneOre(giorno, date) {
      this.selectedDay = giorno;
      this.selectedDate = date;
      let data = new Date(this.selectedYear, this.selectedMonth - 1, giorno);
      this.permesso = this.getPermessoGiorno(data)["type"];
      if (this.permesso == null) {
        this.permesso = "L";
      }
      this.eventiGiorno = this.getDayEvent(data);
      this.dialogRegistrazioneOre = true;
    },
    resetDialogRegistrazioneOre() {
      this.dialogRegistrazioneOre = false;
      this.pernotto = false;
      this.permesso = "";
    },
    apriDialogInserimento(rapportino) {
      this.resetDialogInserimento();
      console.log(rapportino);
      this.updateRapportino = true;
      this.commessaSelezionata = rapportino["c_project_id"];
      this.oreAssistenza = rapportino["oreesterneassistenza"];
      this.oreMontaggio = rapportino["oreesternemontaggio"];
      this.oreInterne = rapportino["oreinterne"];
      this.oreViaggio = rapportino["oreviaggio"];
      this.idRapportino = rapportino["fct_timesheetwh_id"];
      this.numFoglioOre = rapportino["fogliodilavoro"];
      this.tipoPernotto = rapportino["tipopernotto"];
      this.clienteSelezionato = rapportino["c_bpartner_id"];
      this.materialeUtilizzato = rapportino["MaterialeUtilizzato"];
      this.buttonSaveDisabled = false;
      if (rapportino["pernotto"] != "N") {
        this.pernotto = true;
      }
      if (
        rapportino.fogliodilavoro != null &&
        rapportino.fogliodilavoro != "" &&
        rapportino.c_bpartner_id != null
      ) {
        this.sceltaCommessaAttivita = 1;
      }
      let data = new Date(rapportino["timesheetdate"]);
      this.dataRapportino =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
      this.dialogInserimento = true;
    },
    apriDialogInserimentoRecente(commessa) {
      this.resetDialogInserimento();
      if (commessa.fogliodilavoro == null || commessa.fogliodilavoro == "") {
        this.sceltaCommessaAttivita = 0;
        this.commessaSelezionata = commessa.c_project_id;
      } else {
        this.sceltaCommessaAttivita = 1;
        this.numFoglioOre = commessa.fogliodilavoro;
        this.clienteSelezionato = commessa.c_bpartner_id;
      }
      this.dialogInserimento = true;
    },
    resetDialogInserimento() {
      this.materialeUtilizzato = "";
      this.updateRapportino = false;
      this.oreViaggio = 0;
      this.dialogInserimento = false;
      this.oreInterne = 0;
      this.oreAssistenza = 0;
      this.oreMontaggio = 0;
      this.sceltaCommessaAttivita = 0;
      this.commessaSelezionata = 0;
      this.clienteSelezionato = 0;
      this.numFoglioOre = "";
      this.idRapportino = -1;
      this.pernotto = false;
      this.tipoPernotto = "";
      let data = new Date(this.selectedDate);
      this.dataRapportino =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
    },
    salvaGiorno() {
      this.$store.commit("setProgressMessage", "Salvaggio giorno");
      this.$store.commit("setProgressLoading", true);
      let data = {};
      data.Type = this.permesso;
      data.day = this.selectedDate + " 00:00:00";
      data.AD_User_ID = this.$session.get("ad_user_id");

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.day = "s";
      datadef.Type = "s";

      let permesso = this.getPermessoGiorno(this.selectedDate + " 00:00:00");
      let parameters = {};
      if (permesso == "") {
        data.day = this.selectedDate; // + "T00:00:00.000Z";
        delete data.AD_User_ID;
        data.adUserID = this.$session.get("ad_user_id");
        data.type = data.Type;
        delete data.Type;

        parameters.idempiereRestPath = "vitech/createFeriePermessi";
        parameters.data = data;
        this.$store.dispatch("callIdempiereRest", parameters).then(
          (response) => {
            console.log(response);
            if (response.data.result == "OK") {
              this.$store.commit("setProgressLoading", false);
              this.$store.commit("setProgressMessage", "Salvataggio riuscito");
              var that = this;
              setTimeout(function () {
                that.$store.commit("setProgressMessage", null);
                that.$store.commit("setProgressLoading", true);
              }, 1000);
            } else {
              this.$store.commit("setProgressMessage", null);
              var errorMsg = "Salvataggio non riuscito";
              if (response.data.hasOwnProperty("message")) {
                errorMsg = errorMsg + "\n" + response.data.message;
              }
              this.$store.commit("setErrorMessage", errorMsg);
            }
          },
          (error) => {
            console.error("Niente dal server riprovo nuovamente");
          }
        );

        /*
        data.timesheetdate =
        dataRapportino.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";

        parameters.data = data;
        //parameters.datadef = datadef;

        parameters.idempiereRestPath = "vitech/createTimesheetwh"

        console.log(parameters)

        this.$store.dispatch("callIdempiereRest", parameters).then(
          response=>{
            console.log(response)
          },
          error => {
            console.log("ERRORE")
            this.$store.commit("setProgressMessage", null);
            this.$store.commit("setErrorMessage", "Errore nel salvataggio");
            //console.error("Got nothing from server. Prompt user to check internet connection and try again")
          }
        )
        */
        /*
        parameters.urlMethod = "/idempiere/callWebService";
        parameters.debug = true;
        parameters.webServiceName = "CreateFeriePermessi";
        parameters.data = data;
        parameters.datadef = datadef;
        this.$store.dispatch("postAxiosAction", parameters).then(
          response => {
            console.log(response);
          },
          error => {
            console.error("Niente dal server riprovo nuovamente");
          }
        );
        */

        this.listaFerieMalattie.push({
          line: this.listaFerieMalattie.length,
          ad_user_id: this.$session.get("ad_user_id"),
          type: this.permesso,
          day: this.selectedDate + " 00:00:00",
        });
      } else {
        data.fct_holiday_ID = permesso.fct_holiday_id;
        datadef.fct_holiday_ID = "n";

        parameters.webServiceName = "CreateTimesheetwh";
        parameters.data = data;
        parameters.datadef = datadef;

        parameters.urlMethod = "webservices/rest/v1/vitech/updateFerieMalattie";
        parameters.debug = true;

        this.$store.dispatch("postAxiosAction", parameters).then(
          (response) => {
            console.log("Holiday");
            console.log(response);
            if (response[0].result == "OK") {
              this.$store.commit("setProgressLoading", false);
              this.$store.commit("setProgressMessage", "Salvataggio riuscito");
              var that = this;
              setTimeout(function () {
                that.$store.commit("setProgressMessage", null);
                that.$store.commit("setProgressLoading", true);
              }, 1000);
            } else {
              this.$store.commit("setProgressMessage", null);
              var errorMsg = "Salvataggio non riuscito";
              if (response.data.hasOwnProperty("message")) {
                errorMsg = errorMsg + "\n" + response.data.message;
              }
              this.$store.commit("setErrorMessage", errorMsg);
            }
          },
          (error) => {
            console.error("Niente dal server riprovo nuovamente");
          }
        );
        permesso["type"] = this.permesso;
      }
    },
    async inserisciAggiornaRapportino() {
      this.buttonSaveDisabled = true;
      this.calcolaListaOre();

      let dataRapportino = new Date(
        this.selectedYear,
        this.selectedMonth - 1,
        this.selectedDay
      );
      let day = dataRapportino.getDate();
      let month = dataRapportino.getMonth() + 1;
      let sommaOre =
        parseFloat(parseFloat(this.oreInterne).toFixed(2)) +
        parseFloat(parseFloat(this.oreAssistenza).toFixed(2)) +
        parseFloat(parseFloat(this.oreMontaggio).toFixed(2)) +
        parseFloat(parseFloat(this.oreViaggio).toFixed(2));
      sommaOre = sommaOre.toFixed(2);
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var data = {};
      data.AD_User_ID = this.$session.get("ad_user_id");
      data.C_Project_ID = this.commessaSelezionata;
      data.oreinterne = this.oreInterne;
      data.oreesterneassistenza = this.oreAssistenza;
      data.oreesternemontaggio = this.oreMontaggio;
      data.oreviaggio = this.oreViaggio;
      data.FoglioDiLavoro =
        this.sceltaCommessaAttivita == 1 ? this.numFoglioOre : "";
      data.pernotto = this.pernotto ? "Y" : "N";
      data.TipoPernotto = this.tipoPernotto;
      data.timesheetdate =
        dataRapportino.getFullYear() + "-" + month + "-" + day + " 00:00:00";

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.C_Project_ID = "i";
      datadef.oreinterne = "n";
      datadef.oreesterneassistenza = "n";
      datadef.oreesternemontaggio = "n";
      datadef.oreviaggio = "n";
      datadef.pernotto = "s";
      datadef.TipoPernotto = "s";
      datadef.FoglioDiLavoro = "s";
      datadef.timesheetdate = "s";

      if (this.sceltaCommessaAttivita == 1) {
        data.MaterialeUtilizzato = this.materialeUtilizzato;
        datadef.MaterialeUtilizzato = "s";
      }

      datadef.fct_timesheetwh_ID = "i";
      data.fct_timesheetwh_ID = this.idRapportino;
      if (
        sommaOre > 0 &&
        ((this.sceltaCommessaAttivita == 0 && this.commessaSelezionata > 0) ||
          (this.sceltaCommessaAttivita == 1 &&
            this.clienteSelezionato > 0 &&
            this.numFoglioOre != ""))
      ) {
        this.$store.commit("setProgressMessage", "Salvaggio attività");
        this.$store.commit("setProgressLoading", true);
        if (this.updateRapportino) {
          var parameters = {};
          parameters.webServiceName = "CreateTimesheetwh";
          parameters.data = data;
          parameters.datadef = datadef;

          parameters.idempiereRestPath = "vitech/updateTimesheetwh";
          parameters.debug = false;
          await this.$store.dispatch("callIdempiereRest", parameters).then(
            (response) => {
              console.log(response);
              if (response[0].result == "OK") {
                for (let index in this.eventi) {
                  if (
                    this.eventi[index]["rapportino"]["c_project_id"] ==
                    data.C_Project_ID
                  ) {
                    this.eventi[index]["rapportino"]["oreinterne"] =
                      data.oreinterne;
                    this.eventi[index]["rapportino"]["oreesterneassistenza"] =
                      data.oreesterneassistenza;
                    this.eventi[index]["rapportino"]["oreviaggio"] =
                      data.oreviaggio;
                    this.eventi[index]["rapportino"]["oreesternemontaggio"] =
                      data.oreesternemontaggio;
                    this.eventi[index]["rapportino"]["pernotto"] = this.pernotto
                      ? "Y"
                      : "N";
                    this.eventi[index]["rapportino"]["tipopernotto"] =
                      this.tipoPernotto;
                    this.eventi[index]["rapportino"]["MaterialeUtilizzato"] =
                      this.materialeUtilizzato;
                    break;
                  }
                }
                this.$store.commit("setProgressLoading", false);
                this.$store.commit(
                  "setProgressMessage",
                  "Salvataggio riuscito"
                );
                var that = this;
                setTimeout(function () {
                  that.$store.commit("setProgressMessage", null);
                  that.$store.commit("setProgressLoading", true);
                }, 1000);
                this.salvaGiorno();
                this.resetDialogRegistrazioneOre();
                this.apriDialogRegistrazioneOre(day, data.timesheetdate);
                this.resetDialogInserimento();
              } else {
                this.$store.commit("setProgressMessage", null);
                var errorMsg = "Salvataggio non riuscito";
                if (response.data.hasOwnProperty("message")) {
                  errorMsg = errorMsg + "\n" + response.data.message;
                }
                this.$store.commit("setErrorMessage", errorMsg);
              }
              this.update();
              this.loadingDialog = false;
              this.buttonSaveDisabled = false;
            },
            (error) => {
              console.log("ERRORE");
              this.loadingDialog = false;
              this.buttonSaveDisabled = false;
              this.$store.commit("setProgressMessage", null);
              this.$store.commit("setProgressLoading", true);
              this.$store.commit(
                "setErrorMessage",
                (error && error.friendlyMessage) || "Errore nel salvataggio"
              );
            }
          );
          this.calcolaListaOre();
        } else {
          if (
            this.verificaNuovoInserimento(data.timesheetdate, data.C_Project_ID)
          ) {
            if (this.sceltaCommessaAttivita == 1) {
              try {
                data.C_Project_ID = await this.aggiungiCommessa();
              } catch (error) {
                this.buttonSaveDisabled = false;
                this.loadingDialog = false;
                this.$store.commit("setProgressMessage", null);
                this.$store.commit("setProgressLoading", true);
                return;
              }
            }
            var parameters = {};
            parameters.webServiceName = "CreateTimesheetwh";

            delete data.AD_User_ID;
            data.adUserID = this.$session.get("ad_user_id");
            data.cProjectID = data.C_Project_ID;
            delete data.C_Project_ID;

            data.tipoPernotto = data.TipoPernotto;
            delete data.TipoPernotto;

            data.foglioDiLavoro = data.FoglioDiLavoro;
            delete data.FoglioDiLavoro;

            data.materialeUtilizzato = this.materialeUtilizzato;
            delete data.MaterialeUtilizzato;

            data.timesheetdate =
              dataRapportino.getFullYear() +
              "-" +
              month +
              "-" +
              day +
              "T00:00:00.000Z";

            parameters.data = data;
            //parameters.datadef = datadef;

            parameters.idempiereRestPath = "vitech/createTimesheetwh";

            console.log(parameters);

            await this.$store.dispatch("callIdempiereRest", parameters).then(
              (response) => {
                if (response.data.result == "OK") {
                  this.buttonSaveDisabled = false;
                  this.$store.commit("setProgressLoading", false);
                  this.$store.commit(
                    "setProgressMessage",
                    "Salvataggio riuscito"
                  );
                  var that = this;
                  setTimeout(function () {
                    that.$store.commit("setProgressMessage", null);
                    that.$store.commit("setProgressLoading", true);
                  }, 1000);
                  this.salvaGiorno();
                  this.resetDialogRegistrazioneOre();
                  this.apriDialogRegistrazioneOre(day, data.timesheetdate);
                  this.resetDialogInserimento();
                } else {
                  this.$store.commit("setProgressMessage", null);
                  var errorMsg = "Salvataggio non riuscito";
                  if (response.data.hasOwnProperty("message")) {
                    errorMsg = errorMsg + "\n" + response.data.message;
                  }
                  this.$store.commit("setErrorMessage", errorMsg);
                }
                this.update();
              },
              (error) => {
                this.buttonSaveDisabled = false;
                console.log("ERRORE");
                this.$store.commit("setProgressMessage", null);
                this.$store.commit("setErrorMessage", "Errore nel salvataggio");
                //console.error("Got nothing from server. Prompt user to check internet connection and try again")
              }
            );

            /*

            await this.$store
              .dispatch("postAxiosAction", parameters)
              .then(response => {
                console.log(response);
                if (this.sceltaCommessaAttivita == 0) {
                  for (let index in this.commesseAttive) {
                    if (
                      this.commesseAttive[index]["c_project_id"] ==
                      data.C_Project_ID
                    ) {
                      data.prjname = this.commesseAttive[index]["prjname"];
                      break;
                    }
                  }
                } else {
                  data.prjname = "Foglio di lavoro " + this.numFoglioOre;
                }
                data.selectdesc = data.prjname;
                data.c_bpartner_id = this.clienteSelezionato;
                data.c_project_id = this.commessaSelezionata;
                data.fct_timesheetwh_id = response[0].recordID;
                data.fogliodilavoro =
                  this.sceltaCommessaAttivita == 1 ? this.numFoglioOre : "";
                data.tipopernotto = data.TipoPernotto;
                this.eventi.push({
                  name: data["prjname"],
                  start: data["timesheetdate"],
                  end: data["timesheetdate"],
                  color: "accent",
                  rapportino: data
                });
                this.loadingDialog = false;
                this.buttonSaveDisabled = false;
              });
              */
          } else {
            this.loadingDialog = false;
            this.buttonSaveDisabled = false;
            this.$store.commit("setProgressMessage", null);
            this.$store.commit("setProgressLoading", true);
            this.errorText = "Rapportino non salvato: commessa già presente";
            this.errorSnackbar = true;
          }
        }
      } else {
        if (sommaOre <= 0) {
          this.errorText =
            "Rapportino non salvato: la somma delle ore deve essere maggiore di 0";
        } else {
          this.errorText = "Rapportino non salvato: seleziona una commessa";
        }
        this.loadingDialog = false;
        this.buttonSaveDisabled = false;
        this.errorSnackbar = true;
      }
      this.calcolaListaOre();
    },
    aggiungiCommessa() {
      var data = {};
      var parameters = {};

      data.name = "Foglio di Lavoro " + this.numFoglioOre;
      data.c_BPartner_ID = this.clienteSelezionato;
      data.c_Currency_ID = 102;
      data.c_Activity_ID = 1000003;
      data.fct_commessastatus_ID = 1000004;

      parameters.idempiereRestPath = "vitech/createCommessa";
      parameters.data = data;
      return new Promise((resolve, reject) => {
        this.$store.dispatch("callIdempiereRest", parameters).then(
          (response) => {
            console.log(response);
            this.loadingDialog = false;

            var record = response.data && response.data.data;
            if (Array.isArray(record)) {
              record = record[0];
            }
            var id = (record && record.ID) || (response.data && response.data.ID);

            if (!id) {
              var errorMsg = "Creazione commessa non riuscita";
              if (response.data && response.data.message) {
                errorMsg = errorMsg + "\n" + response.data.message;
              }
              this.$store.commit("setErrorMessage", errorMsg);
              reject(new Error(errorMsg));
              return;
            }

            resolve(id);
          },
          (error) => {
            console.error("Niente dal server riprovo nuovamente");
            this.loadingDialog = false;
            var friendlyMessage =
              (error && error.friendlyMessage) ||
              "Impossibile creare la commessa: si è verificato un errore imprevisto.";
            this.$store.commit("setErrorMessage", friendlyMessage);
            reject(error);
          }
        );
      });

      /*
      data.Name = "Foglio di Lavoro " + this.numFoglioOre;
      data.C_BPartner_ID = this.clienteSelezionato;
      data.C_Currency_ID = 102;
      data.C_Activity_ID = 1000003;
      data.fct_commessastatus_ID = 1000004;

      var datadef = {};
      datadef.Name = "s";
      datadef.C_BPartner_ID = "i";
      datadef.C_Currency_ID = "i";
      datadef.C_Activity_ID = "i";
      datadef.fct_commessastatus_ID = "i";

      var parameters = {};
      parameters.webServiceName = "CreateCommessa";
      parameters.data = data;
      parameters.datadef = datadef;

      parameters.urlMethod = "/idempiere/callWebService";
      parameters.debug = false;
      return new Promise(resolve => {
        this.$store.dispatch("postAxiosAction", parameters).then(response => {
          //console.log(response);
          resolve(response[0]["recordID"]);
        });
        this.loadingDialog = false;
      });*/
    },
    eliminaRapportino() {
      this.$refs.confirm
        .open("Cancella rapportino", "Vuoi cancellare il rapportino?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            var data = {};
            data.fct_timesheetwh_id = this.idRapportino;

            var datadef = {};
            datadef.fct_timesheetwh_id = "i";
            var parameters = {};

            parameters.data = data;
            parameters.datadef = datadef;

            parameters.idempiereRestPath = "vitech/deleteTimesheetwh";
            parameters.debug = false;

            this.$store.commit("setProgressMessage", "Cancellazione in corso");
            this.$store.commit("setProgressLoading", true);
            this.$store
              .dispatch("callIdempiereRest", parameters)
              .then(
                (response) => {
                  this.$store.commit("setProgressMessage", null);
                  this.$store.commit("setProgressLoading", true);
                  if (response.data.result == "OK") {
                    this.eventi = this.eventi.filter(function (evento) {
                      return (
                        evento.rapportino.fct_timesheetwh_id !=
                        data.fct_timesheetwh_id
                      );
                    });
                    this.calcolaListaOre();
                    this.resetDialogInserimento();
                    this.resetDialogRegistrazioneOre();
                  } else {
                    var errorMsg = "Cancellazione non riuscita";
                    if (response.data.hasOwnProperty("message")) {
                      errorMsg = errorMsg + "\n" + response.data.message;
                    }
                    this.$store.commit("setErrorMessage", errorMsg);
                  }
                },
                (error) => {
                  this.$store.commit("setProgressMessage", null);
                  this.$store.commit("setProgressLoading", true);
                  this.$store.commit(
                    "setErrorMessage",
                    (error && error.friendlyMessage) ||
                      "Errore nella cancellazione del rapportino"
                  );
                }
              );
          }
        });
    },
    getListaCommesseSelezionabiliServer() {
      return new Promise((resolve) => {
        var parameters = {};
        parameters.idempiereRestPath =  "vitech/getListaCommesseSelezionabiliServer";
        parameters.debug = false;

        this.$store.dispatch("callIdempiereRest", parameters).then(
          (response) => {
            this.commesseAttive = response.data.data;

            //console.log("commesseAttive >> ", this.commesseAttive);

            //this.getListaListaOreServer();
            //this.getAttachmentList();
            resolve();
          },
          (error) => {
            console.error("Niente dal server riprovo nuovamente");
            resolve();
          }
        );
      });
      
    },
    getListaBPartnerServer() {
      var parameters = {};

      parameters.debug = false;

      parameters.idempiereRestPath = "vitech/getListaClienti";
      parameters.debug = false;

      this.$store.dispatch("callIdempiereRest", parameters).then(
        (response) => {
          this.listaBPartner = response.data.data;
        },
        (error) => {
          console.error("Niente dal server riprovo nuovamente");
        }
      );
    },
    getListaEventi() {
      let month = ("0" + this.selectedMonth).slice(-2);

      let dateF = this.selectedYear + "-" + month + "-" + "01" + "T00:00:00";
      var dateFrom = new Date(dateF);
      dateFrom.setDate(-6);
      dateFrom.setDate(dateFrom.getDate());
      var dataStrUniFrom = this.getDataStrUNI(dateFrom);

      let dateT = this.selectedYear + "-" + month + "-" + "28" + "T00:00:00";
      var dateTo = new Date(dateT);
      dateTo.setDate(37);
      dateTo.setDate(dateTo.getDate());
      var dataStrUniTo = this.getDataStrUNI(dateTo);

      var parameters = {};
      var data = {};
      data.dateFrom = dataStrUniFrom + "T00:00:00.000Z";
      data.dateTo = dataStrUniTo + "T00:00:00.000Z";

      //console.log("dataStrUniFrom " + data.dateFrom)
      //console.log("dataStrUniTo " + data.dateTo) 
      
      parameters.data = data;
      parameters.debug = true;

      var verificaStatoGiorno

      parameters.idempiereRestPath = "vitech/getListaListaOreServer";
      parameters.debug = false;

      //console.log("[m]getListaEventi  dataStrUniFrom " + dataStrUniFrom)
      //console.log("[m]getListaEventi  dataStrUniTo " + dataStrUniTo)

      return new Promise((resolve) => {
        this.$store
          .dispatch("callIdempiereRest", parameters)
          .then((response) => {

            //console.log("response AAAA >> " + JSON.stringify(response.data));

            var responseData = response.data;

            let eventi = [];
            const items = Array.isArray(responseData.data) ? responseData.data : [];
            
            //console.log("items >> " + JSON.stringify(items));
            
            items.forEach((evento) => {
              //console.log("evento 111111 >> " + JSON.stringify(evento));
              let start = new Date(evento["timesheetdate"]).toISOString().substring(0, 10);
              eventi.push({
                name: evento["prjname"],
                start: start,
                end: start,
                color: "accent",
                rapportino: evento,
              });
            });
            this.eventi = eventi;
            this.calcolaListaOre();
          });
      });
    },
    getDataStrUNI(sd) {
      var d = new Date(sd);

      var month = String(d.getMonth() + 1);
      var day = String(d.getDate());
      var year = String(d.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return year + "-" + month + "-" + day;
    },
    getEventColor(event) {
      return event.color;
    },
    getDayEvent(data) {
      let dataConfronto = new Date(data);
      return this.eventi.filter(function (evento) {
        let dataEvento = new Date(evento.start);
        dataEvento.setHours(0, 0, 0);
        return dataEvento.getTime() == dataConfronto.getTime();
      });
    },
    getListaFerieMalattie() {
      var that = this;

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.day = "s";
      datadef.Type = "s";

      //carica dettaglio item attivo
      var parameters = {};
      parameters.idempiereRestPath = "vitech/getHoliday";
      parameters.debug = false;

      this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          //console.log(response.data)
          let listaFerieMalattie = response.data.data;
          let date = new Date(this.calendario);
          let dayMin = new Date(date.getFullYear(), date.getMonth(), 1);
          dayMin.setDate(-10);
          let dayMax = new Date(date.getFullYear(), date.getMonth(), 1);
          dayMax.setDate(30+10);
          /*Filto le ferie dell'ultimo mese ± 10 giorni*/
          this.listaFerieMalattie = listaFerieMalattie.filter((item) => {
            let day = new Date(item.day);
            return day.getTime()>=dayMin.getTime() && day.getTime()<=dayMax.getTime();
          });
        });
    },
    getOreGiornaliere(data) {
      let totaleOre = 0;
      let totDecimali = 0;
      let rapportiniGiorno = [];
      let dataGiorno = new Date(data);
      dataGiorno.setHours(0, 0, 0);
      this.eventi.forEach((evento) => {
        let dataEvento = new Date(evento["start"]);
        dataEvento.setHours(0, 0, 0);
        if (dataEvento.getTime() == dataGiorno.getTime()) {
          rapportiniGiorno.push(evento["rapportino"]);
        }
      });
      if (rapportiniGiorno != null) {
        rapportiniGiorno.forEach((rapportino) => {
          totaleOre +=
            parseInt(
              (parseFloat(rapportino["oreinterne"]) + "").split(".")[0]
            ) +
            parseInt(
              (parseFloat(rapportino["oreesternemontaggio"]) + "").split(".")[0]
            ) +
            parseInt(
              (parseFloat(rapportino["oreesterneassistenza"]) + "").split(
                "."
              )[0]
            ) +
            parseInt((parseFloat(rapportino["oreviaggio"]) + "").split(".")[0]);
          let decInterne = (parseFloat(rapportino["oreinterne"]) + "").split(
            "."
          )[1];
          let decAssistenza = (
            parseFloat(rapportino["oreesterneassistenza"]) + ""
          ).split(".")[1];
          let decMontaggio = (
            parseFloat(rapportino["oreesternemontaggio"]) + ""
          ).split(".")[1];
          let decViaggio = (parseFloat(rapportino["oreviaggio"]) + "").split(
            "."
          )[1];
          decInterne =
            decInterne == null ? 0 : parseInt((decInterne + "0").slice(0, 2));
          decMontaggio =
            decMontaggio == null
              ? 0
              : parseInt((decMontaggio + "0").slice(0, 2));
          decAssistenza =
            decAssistenza == null
              ? 0
              : parseInt((decAssistenza + "0").slice(0, 2));
          decViaggio =
            decViaggio == null ? 0 : parseInt((decViaggio + "0").slice(0, 2));
          totDecimali += decInterne + decAssistenza + decMontaggio + decViaggio;
        });
        totaleOre += Math.floor(totDecimali / 60) + (totDecimali % 60) / 100;
        totaleOre = totDecimali % 60 == 30 ? totaleOre + "0" : totaleOre;
      }
      return totaleOre;
    },
    sommaOre(rapportino) {
      let totaleOre =
        parseInt((parseFloat(rapportino["oreinterne"]) + "").split(".")[0]) +
        parseInt(
          (parseFloat(rapportino["oreesternemontaggio"]) + "").split(".")[0]
        ) +
        parseInt(
          (parseFloat(rapportino["oreesterneassistenza"]) + "").split(".")[0]
        ) +
        parseInt((parseFloat(rapportino["oreviaggio"]) + "").split(".")[0]);
      let decInterne = (parseFloat(rapportino["oreinterne"]) + "").split(
        "."
      )[1];
      let decAssistenza = (
        parseFloat(rapportino["oreesterneassistenza"]) + ""
      ).split(".")[1];
      let decMontaggio = (
        parseFloat(rapportino["oreesternemontaggio"]) + ""
      ).split(".")[1];
      let decViaggio = (parseFloat(rapportino["oreviaggio"]) + "").split(
        "."
      )[1];
      decInterne =
        decInterne == null ? 0 : parseInt((decInterne + "0").slice(0, 2));
      decMontaggio =
        decMontaggio == null ? 0 : parseInt((decMontaggio + "0").slice(0, 2));
      decAssistenza =
        decAssistenza == null ? 0 : parseInt((decAssistenza + "0").slice(0, 2));
      decViaggio =
        decViaggio == null ? 0 : parseInt((decViaggio + "0").slice(0, 2));
      let totDecimali = decInterne + decAssistenza + decMontaggio + decViaggio;
      totaleOre += Math.floor(totDecimali / 60) + (totDecimali % 60) / 100;
      totaleOre = totDecimali % 60 == 30 ? totaleOre + "0" : totaleOre;
      return totaleOre;
    },
    verificaNuovoInserimento(data, c_project_id) {
      let eventi = this.getDayEvent(data);
      for (let index in eventi) {
        if (eventi[index]["rapportino"]["c_project_id"] == c_project_id) {
          return false;
        }
      }
      return true;
    },
    getPermessoGiorno(data) {
      let dataConfronto = new Date(data);
      dataConfronto.setHours(0);
      for (let index in this.listaFerieMalattie) {
        let dataFerieMalattie = new Date(this.listaFerieMalattie[index]["day"]);
        dataFerieMalattie.setHours(0);
        if (dataFerieMalattie.getTime() == dataConfronto.getTime()) {
          return this.listaFerieMalattie[index];
        }
      }
      return "";
    },
    getPernotto(data) {
      let dataConfronto = new Date(data);
      for (let index in this.listaPernotto) {
        let dataPernotto = new Date(this.listaPernotto[index]["day"]);
        if (dataPernotto.getTime() == dataConfronto.getTime()) {
          return this.listaPernotto[index];
        }
      }
      return false;
    },
    showEvent({ nativeEvent, event }) {
      this.selectedDate = new Date(event.start);
      console.log(this.selectedDate);
      if (!this.$vuetify.breakpoint.xs) {
        this.apriDialogInserimento(event.rapportino);
      } else {
        this.apriDialogRegistrazioneOre(
          event.start.substring(8, 10),
          event.start
        );
      }
    },
    getColorePermesso(type) {
      for (let index in this.listaTipoPermesso) {
        if (this.listaTipoPermesso[index]["value"] == type) {
          return this.listaTipoPermesso[index]["color"];
        }
      }
      return "";
    },
    getListaCommesseRecenti() {
      var dateFrom = new Date(this.selectedYear, this.selectedMonth - 1, -15);
      dateFrom.setDate(dateFrom.getDate());
      var dataStrUniFrom = this.getDataStrUNI(dateFrom);

      var dateTo = new Date(this.selectedYear, this.selectedMonth - 1, 45);
      dateTo.setDate(dateTo.getDate());
      var dataStrUniTo = this.getDataStrUNI(dateTo);

      var parameters = {};
      var data = {};
      data.dateFrom = dataStrUniFrom + "T00:00:00.000Z";
      data.dateTo = dataStrUniTo + "T00:00:00.000Z";

      //console.log("dataStrUniFrom " + data.dateFrom)
      //console.log("dataStrUniTo " + data.dateTo) 

      parameters.data = data;

      parameters.idempiereRestPath = "vitech/getListaListaOreServer";
      parameters.debug = false;

      this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          this.commesseRecenti = response.data.data;
          this.commesseRecenti = this.commesseRecenti.filter(
            (thing, i, arr) =>
              arr.findIndex((t) => t.c_project_id === thing.c_project_id) === i
          );
          this.commesseRecenti = this.commesseRecenti.filter(function (
            commessa
          ) {
            return commessa.fogliodilavoro == "";
          });
        });
    },
    calcolaListaOre() {
      let month = ("0" + this.selectedMonth).slice(-2);

      let dateF = this.selectedYear + "-" + month + "-" + "01";
      var dateFrom = new Date(dateF);
      dateFrom.setDate(-6);

      let dateT = this.selectedYear + "-" + month + "-" + "28";
      var dateTo = new Date(dateT);
      dateTo.setDate(37);

      for (
        dateFrom;
        dateFrom <= dateTo;
        dateFrom.setDate(dateFrom.getDate() + 1)
      ) {
        let dataStr =
          dateFrom.getFullYear() +
          "-" +
          ("0" + (dateFrom.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dateFrom.getDate()).slice(-2);
        this.listaOreGiornaliere[dataStr] = this.getOreGiornaliere(dataStr);
      }
    },
    apriSchedaMese: function () {
      let mese = this.selectedMonth - 1;
      let anno = this.selectedYear;
      let parameters = {};
      parameters.mese = mese;
      parameters.anno = anno;

      this.$store.dispatch("schedaMese", parameters).then((response) => {
        var datiMese = response.data.mese;

        let ultimoGiorno = new Date(anno, mese + 1, 0).getDate();
        let tipoPernotto = {};
        this.schedaMese = [];
        for (let index in this.listaTipoPernotto) {
          tipoPernotto[this.listaTipoPernotto[index].value] =
            this.listaTipoPernotto[index].name;
        }
        for (let giorno = 1; giorno <= ultimoGiorno; giorno++) {
          this.schedaMese.push({
            num: giorno,
            giorno: this.giorniSettimana[new Date(anno, mese, giorno).getDay()],
            interne: datiMese[giorno]["interne"],
            esterne: datiMese[giorno]["esterne"],
            viaggio: datiMese[giorno]["viaggio"],
            pernotto:
              datiMese[giorno]["pernotto"] == null
                ? "No"
                : tipoPernotto[datiMese[giorno]["pernotto"]],
          });
        }
        this.dialogSchedaMese = true;
      });
    },
    async update() {
      //console.log("update");
      await this.getListaEventi();
      await this.getListaFerieMalattie();
    },
  },
  computed: {
    currentDate: function () {
      let data = new Date();
      let month = ("0" + (data.getMonth() + 1)).slice(-2);
      let day = ("0" + data.getDay()).slice(-2);
      return data.getFullYear() + "-" + month + "-" + day + "T00:00:00";
    },
    selectedMonth: function () {
      let date = new Date(this.selectedDate);
      return date.getMonth() + 1;
    },
    selectedYear: function () {
      let date = new Date(this.selectedDate);
      return date.getFullYear();
    },
    eventiOre: function () {
      this.calcolaListaOre();
      let eventiOre = [
        {
          name: "prova",
          start: "1980-01-01",
        },
      ];
      for (let index in this.listaOreGiornaliere) {
        if (this.listaOreGiornaliere[index] > 0) {
          eventiOre.push({
            name: this.listaOreGiornaliere[index] + " Ore",
            start: index,
            color: "accent",
          });
        }
      }
      return eventiOre;
    },
    eventiVisualizzati: function () {
      if (this.$vuetify.breakpoint.xs) {
        return this.eventiOre;
      }
      return this.eventi;
    },
  },
  mounted: async function () {
    this.calendario = this.currentDate;
    await this.getListaBPartnerServer();
    await this.getListaCommesseSelezionabiliServer();
    console.log("mounted");
    await this.getListaEventi();
    await this.getListaFerieMalattie();
    await this.getListaCommesseRecenti();
    /*setTimeout(
      function () {
        await this.getListaEventi();
        await this.getListaFerieMalattie();
      }.bind(this),
      3000
    );*/
  },
  watch: {
    calendario: async function () {
      console.log("refresh");
      this.selectedDate = this.calendario;
      console.log("watch");
      await this.getListaEventi();
      await this.getListaFerieMalattie();
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (this.$vuetify.breakpoint.xs) {
      if (this.dialogInserimento) {
        this.dialogInserimento = false;
        next(false);
      } else if (this.dialogRegistrazioneOre) {
        this.dialogRegistrazioneOre = false;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$vuetify.breakpoint.xs) {
      if (this.dialogInserimento) {
        this.dialogInserimento = false;
        next(false);
      } else if (this.dialogRegistrazioneOre) {
        this.dialogRegistrazioneOre = false;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>